<template>
  <div class="uploadAttach">
    <div class="attach-title">{{item.label}}</div>
    <div class="attach-upload">
      <div class="bd">
        <van-uploader v-model="files" :before-read="beforeRead" :deletable="!delDisabled" :before-delete="beforeDelete" :max-count="item.upload_filecount" upload-icon="plus" />
      </div>
      <div class="ft" v-if="item.sample_image">
        <van-image width="80" height="80" :src="item.sample_image" fit="contain" @click="preview(item.sample_image)" />
      </div>
      <!-- <div class="extra">
        <van-button :color="themeColor" block size="small"  @click="confirm()">上传</van-button>
        <van-button :color="themeColor" block plain size="small"  @click="filesPreview()">预览</van-button>
      </div> -->
    </div>
  </div>
</template>

<script>
  import iconClear from "@/assets/docpc/clear.png"
  import {
    doctorAttachUpload, doctorAttachRemove, recordUploadPc, recordRemove, signUploadPc, signRemove
  } from '@/api/doctorapi';
  import {
    Toast,
    Dialog,
    ImagePreview
  } from "vant";
  import {
    mapActions,
    mapState
  } from 'vuex';

  export default {
    name: 'uploadAttach',
    components: {
    },
    data() {
      return {
        themeColor: this.themeColor,
        iconClear: iconClear,
        images: [],
        // preImages: [],
        baseFileUrl: this.baseUrl,
        files: [],
        maxsize: 0,
        delDisabled: false,
      }
    },
    props: ['item', 'type'],
    computed: {
    },
    watch: {
      item: {
        handler(newVal, oldVal) {
          this.getData()
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.maxsize = 50 * 1048576
    },
    methods: {
      getData() {
        this.files = []
        for(let i in this.item.value) {
          let ele = this.item.value[i]
          this.files.push({
            id: ele.id?ele.id:'',
            url: this.baseFileUrl + ele.src
          })
        }
      },
      preview(file) {
        let images = []
        images.push(file)
        this.$nextTick(() => {
            ImagePreview(images);
        })
      },
      filesPreview() {
        if(this.files.length==0) return;
        let images = []
        for(let i in this.files) {
          images.push(this.files[i].url)
        }
        this.$nextTick(() => {
            ImagePreview(images);
        })
      },
      confirm() {
        this.$emit('confirm', this.item)
      },
      beforeRead(file) {
        let formData = new window.FormData()
        formData.append('image', file)
        console.log(file, formData)
        if (file.size > this.maxsize) {
          Toast({
            duration: 1500,
            forbidClick: true,
            message: '上传失败，文件大小超过上传限制！',
          });
          return
        }
        this.$nextTick(()=>{
          let uploadAjax = doctorAttachUpload
          if (this.type == 'record') {
            uploadAjax = recordUploadPc
          } else if (this.type == 'sign') {
            uploadAjax = signUploadPc
          }
          uploadAjax(formData).then((res) => {
            this.files.push({
              url: this.baseFileUrl + res.data.data,
              is_New: true,
            })
            this.item.value.push({
              src: res.data.data,
              is_New: true,
            })
            this.$emit('confirm', this.item)
          })
          .catch((err) => {
            Toast(err.response.data.message)
            console.log('err',err)
          })
        })
      },
      beforeDelete(file) {
        if (this.delDisabled) {
          return
        }
        Dialog.confirm({
          message: '确定删除？',
        })
        .then(() => {
          // on confirm
          let index = null
          console.log('beforeDelete', file, this.files, this.item.value)
          if (file.id) {
            for (let i in this.files) {
              if (file.id == this.files[i].id) {
                index = i
              }
            }
            let removeAjax = doctorAttachRemove
            if (this.type == 'record') {
              removeAjax = recordRemove
            } else if (this.type == 'sign') {
              removeAjax = signRemove
            }
            this.delDisabled = true
            removeAjax({id: file.id}).then((res) => {
              this.files.splice(index, 1)
              this.item.value.splice(index, 1)
              this.$emit('confirm', this.item)
              this.delDisabled = false
            })
            .catch((err) => {
              this.delDisabled = false
              Toast(err.response.data.message)
              console.log('err',err)
            })
          } else {
            for (let i in this.files) {
              if (this.files[i].url == file.url) {
                console.log('eeeee', i , file.url, this.files[i].url)
                index = i
              }
            }
            this.files.splice(index, 1)
            this.item.value.splice(index, 1)
            this.$emit('confirm', this.item)
          }
        })
        .catch(() => {
          // on cancel
        });
      },
    }
  }
</script>

<style lang="less">
  .uploadAttach {
    position: relative;
    .attach-title {
      font-size: 16px; margin-bottom: 20px;
    }
    .attach-upload {
      display: flex; align-items: center;
      .bd {
        flex: 1; min-width: 0; margin-right: 50px;
      }
      .extra {
        padding: 0 0 0 20px; width: 100px;
        .van-button {
          margin: 10px 0;
        }
      }
      .van-uploader__preview-image {
        border-radius: 0;
      }
      .van-uploader__upload {
        box-shadow: 0 0 0 1px #eee; border-radius: 0;
      }
      .van-image {
        background: #f3f3f3; box-shadow: 0 0 0 1px #eee;
      }
    }
  }
</style>